import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStore {
  get<T extends string>(key: string): T | null {
    return localStorage.getItem(key) as T | null;
  }

  set(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }
}
